/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type EventTrait = "Autopilot" | "IndividualHold" | "LinkEvent" | "LunchHold" | "OneOnOne" | "TaskHold" | "%future added value";
export type Inconveniences = "External" | "MissedLunch" | "NoMeetingRelief" | "OnNoMeetingDay" | "Other" | "OutsideMeetingHours" | "OutsideWorkingHours" | "Uncrawled" | "%future added value";
export type SchedulingAttendanceSummaryTag = "Best" | "Conflict" | "Current" | "Good" | "InFocusTime" | "Inconvenient" | "MostFocus" | "OverLunch" | "Soonest" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type SchedulingQueryInput = {
    includeConflictSuggestions?: boolean | null | undefined;
    includeRoom: boolean;
    invitees: Array<InviteeContextInput | null>;
    limit: number;
    maxSlot: DayTimeSlotInput;
    minSlot: DayTimeSlotInput;
    minutesDuration: number;
    roomsOverride: Array<string | null>;
    seenSlots: Array<DayTimeSlotInput | null>;
    timeZone: string;
    traits?: Array<EventTrait | null> | null | undefined;
};
export type InviteeContextInput = {
    calendarId: string;
    required: boolean;
};
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type OnboardingScheduleTestEventStepRendererQueryVariables = {
    orgRelayId: string;
    query: SchedulingQueryInput;
    week: unknown;
};
export type OnboardingScheduleTestEventStepRendererQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly schedulingResponseErrorable?: {
            readonly slots?: ReadonlyArray<{
                readonly summary: {
                    readonly availableRooms: ReadonlyArray<string>;
                    readonly freeAttendees: ReadonlyArray<string>;
                    readonly inconvenientForAttendees: ReadonlyArray<string>;
                    readonly focusTimeMinutesCost: number;
                    readonly conflictingAttendees: ReadonlyArray<string>;
                    readonly tags: ReadonlyArray<SchedulingAttendanceSummaryTag | null> | null;
                };
                readonly attendanceImpacts: ReadonlyArray<{
                    readonly calendarId: string;
                    readonly inconveniences: ReadonlyArray<Inconveniences>;
                    readonly hasConflict: boolean;
                    readonly focusTimeMinutesCost: number;
                    readonly conflictingMeetings: ReadonlyArray<string>;
                }>;
                readonly roomImpacts: ReadonlyArray<{
                    readonly roomId: string;
                    readonly available: boolean;
                }>;
                readonly timeRange: {
                    readonly id: string;
                    readonly startTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly offsetMinutes: number | null;
                        readonly millis: number;
                    } | null;
                    readonly endTime: {
                        readonly type: EventTimeType;
                        readonly dateOrDateTime: string;
                        readonly timeZone: string | null;
                        readonly offsetMinutes: number | null;
                        readonly millis: number;
                    } | null;
                } | null;
            }> | undefined;
            readonly message?: string | null | undefined;
            readonly statusCode?: number | null | undefined;
            readonly body?: string | null | undefined;
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"OnboardingScheduleTestEventStepRenderer_org">;
    } | null;
};
export type OnboardingScheduleTestEventStepRendererQuery = {
    readonly response: OnboardingScheduleTestEventStepRendererQueryResponse;
    readonly variables: OnboardingScheduleTestEventStepRendererQueryVariables;
};



/*
query OnboardingScheduleTestEventStepRendererQuery(
  $orgRelayId: ID!
  $query: SchedulingQueryInput!
  $week: LocalWeek!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ...OnboardingScheduleTestEventStepRenderer_org_2XYUdJ
    ... on Org {
      schedulingResponseErrorable(query: $query) {
        __typename
        ... on SchedulingResponse {
          slots {
            summary {
              availableRooms
              freeAttendees
              inconvenientForAttendees
              focusTimeMinutesCost
              conflictingAttendees
              tags
            }
            attendanceImpacts {
              calendarId
              inconveniences
              hasConflict
              focusTimeMinutesCost
              conflictingMeetings
            }
            roomImpacts {
              roomId
              available
            }
            timeRange {
              id
              startTime {
                type
                dateOrDateTime
                timeZone
                offsetMinutes
                millis
              }
              endTime {
                type
                dateOrDateTime
                timeZone
                offsetMinutes
                millis
              }
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
          body
        }
      }
    }
  }
}

fragment OnboardingScheduleTestEventStepRenderer_org_2XYUdJ on Org {
  id
  primaryOrgCalendar
  experiments
  crawlTest
  primaryOrgEmail
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  calculateSmartHoldsErrorable(week: $week) {
    __typename
    ... on SmartHoldCalculationResult {
      events {
        title
        locked
        isClockwiseEvent
        isAllDay
        calendarIds
        organizer {
          urnValue
          responseStatus
        }
        attendees {
          urnValue
          responseStatus
        }
        creator {
          urnValue
        }
        annotatedEvent {
          userTags {
            tag
            states {
              subjectType
              subjectValue
              value
            }
          }
          orgTags {
            tag
            state {
              subjectType
              subjectValue
              value
            }
          }
          id
        }
        eventKey {
          externalEventId
          id
        }
        location
        startTime {
          dateOrDateTime
          millis
        }
        endTime {
          dateOrDateTime
          millis
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        } as any,
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "week"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Variable",
            "name": "week",
            "variableName": "week"
        } as any
    ], v4 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "focusTimeMinutesCost",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v10 = [
        (v6 /*: any*/),
        (v7 /*: any*/),
        (v8 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any,
        (v9 /*: any*/)
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulingSlot",
                "kind": "LinkedField",
                "name": "slots",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingAttendanceSummary",
                        "kind": "LinkedField",
                        "name": "summary",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "availableRooms",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "freeAttendees",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconvenientForAttendees",
                                "storageKey": null
                            },
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingAttendees",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tags",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingAttendanceImpact",
                        "kind": "LinkedField",
                        "name": "attendanceImpacts",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "calendarId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inconveniences",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasConflict",
                                "storageKey": null
                            },
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "conflictingMeetings",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SchedulingRoomImpact",
                        "kind": "LinkedField",
                        "name": "roomImpacts",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roomId",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "available",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "TimeRange",
                        "kind": "LinkedField",
                        "name": "timeRange",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "startTime",
                                "plural": false,
                                "selections": (v10 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "endTime",
                                "plural": false,
                                "selections": (v10 /*: any*/),
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "SchedulingResponse",
        "abstractKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v16 = [
        (v15 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v18 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v19 = [
        (v7 /*: any*/),
        (v9 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingScheduleTestEventStepRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "args": (v3 /*: any*/),
                            "kind": "FragmentSpread",
                            "name": "OnboardingScheduleTestEventStepRenderer_org"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "schedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v11 /*: any*/),
                                        (v12 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "OnboardingScheduleTestEventStepRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v13 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "crawlTest",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgEmail",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "resolveOverrides",
                                            "value": false
                                        }
                                    ],
                                    "concreteType": "UserWorkingHours",
                                    "kind": "LinkedField",
                                    "name": "userWorkingHours",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasBeenSet",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "WorkingHours",
                                            "kind": "LinkedField",
                                            "name": "workingHours",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v6 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DaySetting",
                                                    "kind": "LinkedField",
                                                    "name": "daySettings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "day",
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DayOverride",
                                                    "kind": "LinkedField",
                                                    "name": "dayOverrides",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "date",
                                                            "storageKey": null
                                                        },
                                                        (v14 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userWorkingHours(resolveOverrides:false)"
                                },
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "calculateSmartHoldsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v13 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Event",
                                                    "kind": "LinkedField",
                                                    "name": "events",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "title",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "locked",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isClockwiseEvent",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isAllDay",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "organizer",
                                                            "plural": false,
                                                            "selections": (v16 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "attendees",
                                                            "plural": true,
                                                            "selections": (v16 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Attendee",
                                                            "kind": "LinkedField",
                                                            "name": "creator",
                                                            "plural": false,
                                                            "selections": [
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AnnotatedEvent",
                                                            "kind": "LinkedField",
                                                            "name": "annotatedEvent",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "UserTag",
                                                                    "kind": "LinkedField",
                                                                    "name": "userTags",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v17 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TagState",
                                                                            "kind": "LinkedField",
                                                                            "name": "states",
                                                                            "plural": true,
                                                                            "selections": (v18 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "OrgTag",
                                                                    "kind": "LinkedField",
                                                                    "name": "orgTags",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v17 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "TagState",
                                                                            "kind": "LinkedField",
                                                                            "name": "state",
                                                                            "plural": false,
                                                                            "selections": (v18 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventKey",
                                                            "kind": "LinkedField",
                                                            "name": "eventKey",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "externalEventId",
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "location",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "startTime",
                                                            "plural": false,
                                                            "selections": (v19 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "endTime",
                                                            "plural": false,
                                                            "selections": (v19 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SmartHoldCalculationResult",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "schedulingResponseErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v13 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "3bf8fee13c1c6ab6326916b37f29242f",
            "id": null,
            "metadata": {},
            "name": "OnboardingScheduleTestEventStepRendererQuery",
            "operationKind": "query",
            "text": "query OnboardingScheduleTestEventStepRendererQuery(\n  $orgRelayId: ID!\n  $query: SchedulingQueryInput!\n  $week: LocalWeek!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ...OnboardingScheduleTestEventStepRenderer_org_2XYUdJ\n    ... on Org {\n      schedulingResponseErrorable(query: $query) {\n        __typename\n        ... on SchedulingResponse {\n          slots {\n            summary {\n              availableRooms\n              freeAttendees\n              inconvenientForAttendees\n              focusTimeMinutesCost\n              conflictingAttendees\n              tags\n            }\n            attendanceImpacts {\n              calendarId\n              inconveniences\n              hasConflict\n              focusTimeMinutesCost\n              conflictingMeetings\n            }\n            roomImpacts {\n              roomId\n              available\n            }\n            timeRange {\n              id\n              startTime {\n                type\n                dateOrDateTime\n                timeZone\n                offsetMinutes\n                millis\n              }\n              endTime {\n                type\n                dateOrDateTime\n                timeZone\n                offsetMinutes\n                millis\n              }\n            }\n          }\n        }\n        ... on GraphEntityError {\n          message\n          statusCode\n          body\n        }\n      }\n    }\n  }\n}\n\nfragment OnboardingScheduleTestEventStepRenderer_org_2XYUdJ on Org {\n  id\n  primaryOrgCalendar\n  experiments\n  crawlTest\n  primaryOrgEmail\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  calculateSmartHoldsErrorable(week: $week) {\n    __typename\n    ... on SmartHoldCalculationResult {\n      events {\n        title\n        locked\n        isClockwiseEvent\n        isAllDay\n        calendarIds\n        organizer {\n          urnValue\n          responseStatus\n        }\n        attendees {\n          urnValue\n          responseStatus\n        }\n        creator {\n          urnValue\n        }\n        annotatedEvent {\n          userTags {\n            tag\n            states {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          orgTags {\n            tag\n            state {\n              subjectType\n              subjectValue\n              value\n            }\n          }\n          id\n        }\n        eventKey {\n          externalEventId\n          id\n        }\n        location\n        startTime {\n          dateOrDateTime\n          millis\n        }\n        endTime {\n          dateOrDateTime\n          millis\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '3664ee7b21faff9f666fe9baabee8052';
export default node;
